import React from 'react';
import { AcceptBlock, LangBlock } from '../../global';
import { WebStorage } from '../../../storage';
import {
    AdminBadge,
    AdminButton,
    AdminGrid,
    AdminPageWrap,
    AdminSection,
    AdminStatCard,
} from './admin.ui';

type Props = {
    diskSizeGB: number;
    pausedAlert: boolean;
    loadAlert: () => void;
};

export const AdminOverview = ({ diskSizeGB, pausedAlert, loadAlert }: Props) => {
    const [, , LangString] = LangBlock();

    return (
    <AdminPageWrap>
        <AdminSection
            title={LangString('AdminOverviewTitle')}
            subtitle={LangString('AdminOverviewSubtitle')}
        >
            <AdminGrid columns={2}>
                <AdminStatCard
                    label={LangString('AdminDiskFree')}
                    value={`${diskSizeGB.toFixed(2)} GB`}
                    tone={diskSizeGB < 4 ? 'danger' : 'ok'}
                />
                <AdminStatCard
                    label={LangString('AdminAlertSystem')}
                    value={
                        <AdminBadge tone={pausedAlert ? 'danger' : 'ok'}>
                            {!pausedAlert ? LangString('AdminEnabled') : LangString('AdminDisabled')}
                        </AdminBadge>
                    }
                    action={
                        <AdminButton
                            variant="primary"
                            size="sm"
                            onClick={async (e) => {
                                e.preventDefault();

                                if (!(await AcceptBlock())) {
                                    return;
                                }

                                WebStorage.ApiRequest('/api/admin/pauseAlert').then((res) => {
                                    if (res.status) {
                                        loadAlert();
                                    }
                                });
                            }}
                        >
                            {LangString('AdminSwitchState')}
                        </AdminButton>
                    }
                />
            </AdminGrid>
        </AdminSection>
    </AdminPageWrap>
    );
};
